export default __webpack_public_path__ + "static/thecloudors-intro-f3cc07982298aae20d7a3e49e6918e4f.mp4";